module.exports = __webpack_public_path__ + "static/img/img4.199d02a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img4.png
// module id = Zbgw
// module chunks = 0